import { Stack, Text, Title } from '@mantine/core';

import {
  H2HPaymentTabs,
  H2HPaymentsFilter,
  H2HPaymentsTable,
  useGetH2HPayments,
  useH2HPaymentActions,
} from '@/modules/h2h-payments';

export const H2HPayments = () => {
  const queue = useGetH2HPayments();
  const actions = useH2HPaymentActions();

  return (
    <Stack gap="sm">
      <div>
        <Title order={4}>Платежи H2H</Title>
        <Text size="sm" c="dimmed">Операционная очередь ручной проверки и двухэтапного завершения</Text>
      </div>
      <H2HPaymentTabs
        value={queue.params.tab}
        counts={queue.counts}
        onChange={queue.handleTabChange}
      />
      <H2HPaymentsFilter
        onSubmit={queue.handleFilterChange}
        onReset={queue.handleFilterReset}
      />
      <H2HPaymentsTable
        items={queue.items}
        itemsCount={queue.itemsCount}
        pageSize={queue.params.pageSize ?? 30}
        currentPage={queue.params.page ?? 1}
        onPageChange={queue.handlePaginationChange}
        isLoading={queue.isLoading}
        isActionLoading={actions.isLoading}
        onCredit={actions.creditClient}
        onFinalize={actions.finalizePayment}
        onReject={actions.rejectPayment}
        onResolveProviderConflict={actions.resolveProviderConflict}
        onReviewDiscrepancy={actions.reviewDiscrepancy}
        onHideFromQueue={actions.hideFromQueue}
        showHideFromQueue={queue.params.tab !== 'all'}
      />
    </Stack>
  );
};
